const muiSelectTheme = (theme) => {
  theme.overrides.MuiSelect = {
    select: {
      '&:focus': {
        backgroundColor: 'transparent',
      },
    },
    selectMenu: {
      whiteSpace: 'unset',
    },
  };
};

export default muiSelectTheme;
